export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./loading.vue?vue&type=template&id=19188418"


//////////////////
// WEBPACK FOOTER
// ./skins/xkiosk/components/_base/loading/africa/loading.vue?vue&type=template&id=19188418
// module id = Oip2
// module chunks = 37